import { render, staticRenderFns } from "./#zhiwei.vue?vue&type=template&id=27d26802&"
import script from "./#zhiwei.vue?vue&type=script&lang=js&"
export * from "./#zhiwei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports